module.exports = __webpack_public_path__ + "img/qrcode-teacat.1e250088.png";